document.addEventListener('DOMContentLoaded', () => {
 /* ---------- CONFIG ---------- */
  const weights = {
    Small: ' <20 lbs', 
    Medium: ' ~40 lbs',
    Large: ' ~60 lbs',
    Jumbo: '60+ lbs',
    'Medium/Large': '~40-60 lbs',
    'XL/Jumbo': '60+ lbs',
    'Two-Pack': 'Save 10%', 
    'Three-Pack': 'Save 25%', 
  };
  const descriptions = {
    Small: 'Perfect for Small Breeds & Light Chewers',
    Medium: 'Just right for Medium Breeds & Moderate Chewers',
    Large: 'Ideal for Larger Breeds & Stronger Chewers',
    Jumbo: 'Heavy-Duty Chews for Power Chewers & Giant Breeds',
    'Medium/Large': 'Ideal for Larger Breeds & Stronger Chewers',
    'XL/Jumbo': 'Heavy-Duty Chews for Power Chewers & Giant Breeds',
    'Two-Pack': 'Stock up and save',
    'Three-Pack': 'Best value — save even more',
  };
  const validOptions = Object.keys(weights);

  /* ---------- VARIANT LABEL ENHANCEMENT (inline info instead of tooltip) ---------- */
  const enhanceVariantLabels = () => {
    document.querySelectorAll('variant-selects').forEach((vs) => {
      const sizeDetails = vs.querySelector('.size-details');
      if (!sizeDetails) return;

      vs.querySelectorAll('input[type="radio"]').forEach((input) => {
        if (!validOptions.includes(input.value)) return;

        const label = document.querySelector(`label[for="${input.id}"]`);
        if (!label) return;

        if (!label.querySelector('.weight-label')) {
          const w = document.createElement('div');
          w.className = 'weight-label';
          w.textContent = weights[input.value];
          label.appendChild(w);
        }

        // Remove previous change listener to avoid stacking
        input.removeEventListener('change', input._sizeDetailChangeListener);

        // Add new change listener
        input._sizeDetailChangeListener = () => {
          sizeDetails.innerHTML = `
            <div class="size-description">
              ${descriptions[input.value]}
            </div>
          `;
        };

        input.addEventListener('change', input._sizeDetailChangeListener);

        // If pre-selected, show it immediately
        if (input.checked) {
          input._sizeDetailChangeListener();
        }
      });
    });
  };

  /* ---------- PRODUCT-TYPE TOGGLE ---------- */
  const setActiveProductTypeButtonByCurrentProduct = () => {
    document.querySelectorAll('[data-section]').forEach((section) => {
      const url = section.dataset.url;
      if (!url) return;
      const toggle =
        document.querySelector(`[data-section-toggle="${section.dataset.section}"]`) ||
        section.closest('.product-type-toggle') ||
        document.querySelector('.product-type-toggle');
      if (!toggle) return;
      toggle
        .querySelectorAll('.product-type-button')
        .forEach((b) => b.classList.toggle('active', b.dataset.url === url));
    });
  };

  const ajaxSwap = async (button) => {
    const url = button.dataset.url;
    const sectionId = button.dataset.sectionId;
    if (!url || !sectionId) return;

    const container = document.querySelector(`[data-section="${sectionId}"]`);
    if (!container || container.dataset.url === url) return;

    try {
      const html = await (await fetch(`${url}?section_id=${sectionId}`)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector(`[data-section="${sectionId}"]`);
      if (!fresh) return;

      container.outerHTML = fresh.outerHTML;
      const replaced = document.querySelector(`[data-section="${sectionId}"]`);

      if (typeof initProductForm === 'function') initProductForm();
      else replaced.dispatchEvent(new Event('productForm:reinit', { bubbles: true }));

      replaced
        .querySelector('select[name="id"]')
        ?.dispatchEvent(new Event('change', { bubbles: true }));

      history.pushState(null, '', replaced.dataset.url);
      refreshAll();
    } catch (e) {
      console.error('AJAX swap failed', e);
    }
  };

  const setupProductTypeToggles = () => {
    setActiveProductTypeButtonByCurrentProduct();
    document.body.addEventListener('click', (e) => {
      const btn = e.target.closest('.product-type-button');
      if (!btn) return;
      btn
        .closest('.product-type-toggle')
        ?.querySelectorAll('.product-type-button')
        .forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      ajaxSwap(btn);
    });
  };

  /* ---------- REFRESH & OBSERVE ---------- */
  const refreshAll = () => {
    enhanceVariantLabels();
    setActiveProductTypeButtonByCurrentProduct();
  };

  let refreshDebounce;
  new MutationObserver((muts) => {
    if (
      muts.some((m) =>
        Array.from(m.addedNodes).some(
          (n) =>
            n.nodeType === 1 &&
            (n.matches('variant-selects') ||
              n.querySelector?.('variant-selects input[type="radio"]'))
        )
      )
    ) {
      clearTimeout(refreshDebounce);
      refreshDebounce = setTimeout(refreshAll, 30);
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------- INIT ---------- */
  setupProductTypeToggles();
  refreshAll();
});
